/** The type scale. Every font-size on the site snaps to one of these steps. */
export const size = {
  xxsmall: 'var(--size-xxsmall)',
  xsmall: 'var(--size-xsmall)',
  small: 'var(--size-small)',
  main: 'var(--size-main)',
  medium: 'var(--size-medium)',
  large: 'var(--size-large)',
  xlarge: 'var(--size-xlarge)',
  title: 'var(--size-title)',
  display: 'var(--size-display)',
} as const;

export type SizeToken = keyof typeof size;
